<template>
  <div class="troubleshoot-menu">
    <h3 class="description-title" v-if="title">
      {{ title }}
    </h3>

    <ul>
      <li
        v-for="(content, index) in menuContent"
        :key="index"
        :class="{ active: index === value }"
        @click="$emit('input', index)"
      >
        <p>
          {{ content }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },

    menuContent: {
      type: Array,
      required: true
    },

    value: {
      type: Number,
      default: -1
    }
  }
};
</script>

<style lang="scss" scoped>
.troubleshoot-menu {
  border: 1px solid #cbd6d6;
  border-radius: 5px;
  padding: 20px;
  background-color: #fff;

  h3 {
    @include mobile {
      font-size: 18px;
      margin-bottom: 10px;
    }
  }

  ul {
    list-style: none;

    li {
      color: #6e6e6e;
      font-weight: 600;
      cursor: pointer;
      padding: 10px 0;
      display: flex;
      align-items: center;
      border-bottom: 1px solid transparent;

      @include mobile {
        padding: 5px 0;
      }

      p {
        flex: 1 1 auto;
        padding-right: 20px;
        font-size: 16px;
        transition: 0.3s;
        pointer-events: none;

        @include mobile {
          font-size: 14px;
        }
      }

      &:after {
        content: "";
        display: inline-block;
        pointer-events: none;
        border: 2px solid;
        border-color: #6e6e6e #6e6e6e transparent transparent;
        width: 4px;
        height: 4px;
        transform: rotateZ(45deg);
        transition: 0.3s;
      }

      &:hover {
        color: #44b8eb;

        &:after {
          border-color: #44b8eb #44b8eb transparent transparent;
        }
      }

      &.active {
        color: #44b8eb;
      }
    }
  }
}
</style>
